import styled from 'styled-components';
import HamQuest from '../../api/HamQuestGiver';
import { QuestRoute } from '../../api/QuestRoutes';
import Button from '../../forms/Button';
import Form from '../../forms/Form';
import Input from '../../forms/Input';
import Preput from '../../forms/Preput';
import Select from '../../forms/Select';
import GetState from '../../GetState';
import ModalFactory from '../../Modal';
import { userRoles } from '../../RoleProtected';
import ManagementRow from '../../table/ManagementRow';
import Table, { Ctd } from '../../table/Table';
import { generateId, shortHandDateTimeUTC, shortHandDate } from '../../utility/functions';
import AddPlateReadMessageForm from '../../processors/AddPlateReadMessageForm';
import RequireFeature, { Features } from '../../RequireFeature';

const CustomerPlateReadMessages = ({ plate, isCustomer, ...props }) => {
    const [customerPlateMessagesList, refreshMessagesList]  = GetState(QuestRoute.plateReads.customerMessages(plate))
    
    const renderActionButtons = (e) => {
        var r = [];
        if(!e.dateViewed || e.dateViewed === '')
        {
            r.push(<Button roles={userRoles.editProducts} key={e.plateMessageId} onClick={()=> deletePlateMessage(e)} icon='trash'>Delete</Button>);

        }
        return r
    }

    const addPlateMessage = () => {
        let id = generateId();
        if(!plate && isCustomer)
        {
            ModalFactory.show({
                id,
                title: 'Add Plate Read Message',
                type: 'error',
                body: (<>Customer plate information is missing or invalid.<br />Please ensure primary license plate media has been configured and is active status.</>)

            });
        }
        else 
        {            
            ModalFactory.show({
                id,
                title: 'Add Plate Read Message',
                body: <AddPlateReadMessageForm modalId={id} platesList={[plate]} callback={() => refreshMessagesList()} />
                
            });            
        }
    }    


    const deletePlateMessage = (message) => {
        ModalFactory.confirmAndProcess({
            confirmation: {
                title: `Are you sure?`,
                body: `Are you sure you want to delete this message?`,
                type: 'warning',
            },
            promise: {
                title: 'Deleting Message.',
                body: `Deleting message for customer.`,
                callback: () => HamQuest.delete(QuestRoute.plateReads.messages(message.plateMessageId))
            },
            confirmed: {
                title: 'Success',
                body: `Message successfully deleted.`,
                type: 'success'
            },
            finally: () => refreshMessagesList()
        })
    }

    const tableConfig = {
        data: customerPlateMessagesList,
        controls: [
            <Button roles={userRoles.editProducts} onClick={addPlateMessage}>Add Message</Button>
        ],
        headers: [
            {label: 'Message'},
            {label: 'Priority'},
            {label: 'Expires'},
            {label: 'Date Viewed'}
        ],
        renderFormat: (e) => (
            <ManagementRow 
                key={e.plateMessageId}
                controls={renderActionButtons(e)}
                layout='elipsis' 
            >
                <td>{e.message}</td>               
                <td>{e.priority}</td>
                <td>{e.expirationDate === undefined ? '' : shortHandDate(e.expirationDate)}</td>
                <td>{e.dateViewed === undefined ? '' : shortHandDateTimeUTC(e.dateViewed)}</td>
            </ManagementRow>
        )
    }

    return (
        <RequireFeature requiredFeatures={Features.PlateReads}>
            <h4>Messages</h4>                
            <Table config={tableConfig} />
        </RequireFeature>
    );
}

export default CustomerPlateReadMessages;